// extracted by mini-css-extract-plugin
export default {"root":"IsLegacyCase_root__m3ewW","title":"IsLegacyCase_title__fU2vX","subtitle":"IsLegacyCase_subtitle__++l1x"};